import PropTypes from 'prop-types';
import React from "react";
import {HashRouter as Router} from 'react-router-dom'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from "react-query/devtools";
import {ThemeProvider} from '@emotion/react'
import {theme} from 'Styles/theme'
import {TenantFormProvider} from "./tenantForm";

const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

function AppProviders({ children }) {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <Router>
                    <TenantFormProvider>
                        {children}
                        <ReactQueryDevtools initialIsOpen/>
                    </TenantFormProvider>
                </Router>
            </ThemeProvider>
        </QueryClientProvider>
    );
}
AppProviders.propTypes = {
    children: PropTypes.any
}

export { AppProviders }

// TODO: Add AuthProvider in when we have decision on Auth approach
/* <AuthProvider>{children}</AuthProvider> */

// TODO: add config when TenantCreate auth Tenants is done
// const queryConfig = {
//   queries: {
//     useErrorBoundary: true,
//     refetchOnWindowFocus: false,
//     retry(failureCount, error) {
//       if (error.status === 404) return false
//       else if (failureCount < 2) return true
//       else return false
//     },
//   },
// }